module.exports = __webpack_public_path__ + "static/banner3-093f1861fc92b3a0ba497ece177b27e6.gif";